package empiresmp.feature.gallery.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.functions.blur
import com.varabyte.kobweb.compose.css.functions.saturate
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.backdropFilter
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.shapes.Rect
import com.varabyte.kobweb.silk.theme.shapes.clip
import empiresmp.components.PlatformExt.isMobilePlatform
import empiresmp.components.fade.Crossfade
import empiresmp.feature.gallery.model.GalleryItem
import empiresmp.feature.gallery.model.url
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import ru.astrainteractive.kobwebx.core.theme.composable.LocalSitePalette
import ru.astrainteractive.kobwebx.core.theme.util.ThemeExt.typography

@Suppress("LongMethod")
@Composable
internal fun GalleryItemComposable(
    item: GalleryItem,
    onClick: () -> Unit
) {
    val theme = LocalSitePalette.current
    val index = remember { mutableStateOf(0) }
    Column(
        modifier = Modifier.Companion
            .clip(Rect(theme.dimens.S))
            .background(theme.colors.colorPrimary)
            .padding(theme.dimens.S)
            .cursor(Cursor.Pointer)
            .onClick { onClick.invoke() }
            .thenIf(isMobilePlatform, Modifier.fillMaxWidth())
            .thenIf(!isMobilePlatform, Modifier.width(30.percent))
            .aspectRatio(16f / 9f),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Crossfade(
            targetState = item.images[index.value % item.images.size].url,
            modifier = Modifier.fillMaxSize()
        ) { url ->
            Image(
                src = url,
                modifier = Modifier.Companion
                    .fillMaxSize()
                    .objectFit(ObjectFit.Cover)
                    .clip(Rect(theme.dimens.S))
            )
            Column(
                Modifier.Companion
                    .align(Alignment.TopEnd)
                    .padding(topBottom = theme.dimens.XS, leftRight = theme.dimens.S),
                verticalArrangement = Arrangement.spacedBy(theme.dimens.XS),
                horizontalAlignment = Alignment.End
            ) {
                Column(
                    modifier = Modifier.Companion
                        .clip(Rect(theme.dimens.S))
                        .backgroundColor(theme.colors.colorSecondary.toRgb().copy(alpha = 170))
                        .backdropFilter(saturate(180.percent), blur(5.px))
                        .boxShadow(spreadRadius = 1.px, color = theme.colors.colorSecondary)
                        .padding(topBottom = theme.dimens.XS, leftRight = theme.dimens.S),
                    horizontalAlignment = Alignment.Start,
                    verticalArrangement = Arrangement.spacedBy(theme.dimens.XS)
                ) {
                    SpanText(
                        text = "Сезон ${item.season}",
                        modifier = theme.typography.h5
                            .toModifier()
                            .fontWeight(FontWeight.Companion.Bold)
                            .color(theme.colors.colorOnPrimary)
                            .cursor(Cursor.Companion.Text)
                    )
                }
                Column(
                    modifier = Modifier.Companion
                        .clip(Rect(theme.dimens.S))
                        .backgroundColor(theme.colors.colorSecondary.toRgb().copy(alpha = 170))
                        .backdropFilter(saturate(180.percent), blur(5.px))
                        .boxShadow(spreadRadius = 1.px, color = theme.colors.colorSecondary)
                        .padding(topBottom = theme.dimens.XS, leftRight = theme.dimens.S),
                    horizontalAlignment = Alignment.Start,
                    verticalArrangement = Arrangement.spacedBy(theme.dimens.XS)
                ) {
                    SpanText(
                        text = "Сервер ${item.server}",
                        modifier = theme.typography.h5
                            .toModifier()
                            .fontWeight(FontWeight.Companion.Bold)
                            .color(theme.colors.colorOnPrimary)
                            .cursor(Cursor.Companion.Text)
                    )
                }
            }

            Column(
                modifier = Modifier.Companion
                    .fillMaxWidth()
                    .align(Alignment.BottomCenter)
                    .backgroundColor(theme.colors.colorPrimary.toRgb().copy(alpha = 230))
                    .backdropFilter(saturate(180.percent), blur(5.px))
                    .boxShadow(spreadRadius = 1.px, color = theme.colors.colorPrimary),
                horizontalAlignment = Alignment.Start,
                verticalArrangement = Arrangement.spacedBy(theme.dimens.XS)
            ) {
                SpanText(
                    text = item.title,
                    modifier = theme.typography.h5
                        .toModifier()
                        .fontWeight(FontWeight.Companion.Bold)
                        .color(theme.colors.colorOnPrimary)
                        .cursor(Cursor.Companion.Text)
                )
                SpanText(
                    text = item.description.orEmpty(),
                    modifier = theme.typography.body1
                        .toModifier()
                        .fontWeight(FontWeight.Companion.Normal)
                        .color(theme.colors.colorOnSecondary)
                        .cursor(Cursor.Companion.Text)
                )
            }
        }
    }
}
